import * as React from "react";
import { cn } from "@app/ui/lib/Utils";
import { Tooltip } from "@app/ui/components/Tooltip";

export interface HintTooltipProps {
  /** hover/focus/터치로 떴을 때 보여줄 설명. */
  content: React.ReactNode;
  /** 트리거 아이콘(버튼)에 붙는 클래스. 에러 상태에서 색을 destructive 로 바꿀 때 쓴다. */
  className?: string;
  /** 스크린리더용 트리거 레이블. 기본값은 "설명 보기". */
  label?: string;
}

/**
 * Input 의 left/right 슬롯에 넣어 쓰는 안내 아이콘. 클릭·hover·터치하면 {@link Tooltip}
 * 으로 설명이 뜬다 — 입력 아래에 상시 텍스트를 깔지 않고, 원할 때만 이유를 보여주려는 UI.
 *
 * 터치: {@link Tooltip} 이 tap(click) 에도 열어주므로 모바일에서도 첫 탭에 뜬다.
 */
const HintTooltip = ({ content, className, label = "설명 보기" }: HintTooltipProps) => {
  return (
    <Tooltip content={content}>
      <button
        type="button"
        aria-label={label}
        // tabIndex={-1}: 폼 탭 순서(이메일→비밀번호→제출)에 끼어들지 않게. 클릭·hover·터치로만 연다.
        tabIndex={-1}
        className={cn(
          "flex size-5 items-center justify-center rounded-full text-current outline-none",
          className,
        )}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="size-4"
          aria-hidden
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
      </button>
    </Tooltip>
  );
};
HintTooltip.displayName = "HintTooltip";

export { HintTooltip };
